import { ExcludedAccountCodeFromCreate } from "@/enums/enums";

export function FilterAccountOfTransaction(_accountList: any) {
  const accountList: any = [];
  const ExcludedAccountCodeFromCreateTransaction = Object.values(ExcludedAccountCodeFromCreate);
  _accountList.forEach((account: any) => {
    const accountExcluded = ExcludedAccountCodeFromCreateTransaction.find((item) => {
      return item == account.code ? true : false;
    });
    if (!accountExcluded) {
      accountList.push(account);
    }
  });

  const sortAccountList: any = [];
  const primaryAccountType = "5";
  accountList.forEach((account: any) => {
    const subStringAccountCode = account.code.substring(0, 1);
    if (subStringAccountCode == primaryAccountType) {
      sortAccountList.push(account);
    }
  });
  accountList.forEach((account: any) => {
    const accountSelected = sortAccountList.find((item: any) => {
      return item.code == account.code ? true : false;
    });

    if (!accountSelected) {
      sortAccountList.push(account);
    }
  });

  return sortAccountList;
}
